type LogoProps = {
  color?: "white" | "black";
  className?: string;
};

export default function LogoFooter({ color = "black", className = "" }: LogoProps) {
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/assets/images/logo-footer.png"
        alt="TalentLink Logo"
        className={`
          h-10 w-auto transition-all duration-300
          ${color === "black" ? "" : ""}
        `}
      />
    </div>
  );
}
